import { baseApi } from '@/services/index';

const resource = process.env.VUE_APP_RESOURCE_SICUDGPD_EST_CRD;

export default {
  put(payload) {
    return baseApi.put(`${resource}3`, payload);
  },
};
